import { render, staticRenderFns } from "./BankCardHomeInfo.vue?vue&type=template&id=54089061&"
import script from "./BankCardHomeInfo.vue?vue&type=script&lang=js&"
export * from "./BankCardHomeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports